// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  color: var(--ca-text-primary, #202938);
}

.error-dialog {
  box-sizing: border-box;
  width: 100%;
  max-width: 32rem;
  padding: 0.5rem 0.75rem 0.75rem;
  color: var(--ca-text-primary, #202938);
  background: var(--ca-surface, #ffffff);
  text-align: center;
}

.error-dialog__icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 4.5rem;
  height: 4.5rem;
  margin: 0 auto 1.25rem;
  border: 1px solid var(--ca-danger, #dc3545);
  border-radius: 50%;
  background-color: var(--ca-danger-bg, #fff0f1);
}

.error-dialog__icon {
  display: block;
  color: var(--ca-danger, #dc3545);
  font-size: 2.15rem;
  line-height: 1;
}

.error-dialog__content {
  max-width: 27rem;
  margin: 0 auto;
}

.error-dialog__title {
  margin: 0 0 0.625rem;
  color: var(--ca-text-primary, #202938);
  font-size: clamp(1.4rem, 3vw, 1.7rem);
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -0.015em;
  overflow-wrap: anywhere;
}

.error-dialog__message {
  margin: 0;
  color: var(--ca-text-secondary, #5c6675);
  font-size: 1rem;
  line-height: 1.65;
  overflow-wrap: anywhere;
}

.error-dialog__actions {
  display: flex;
  justify-content: center;
  margin-top: 1.75rem;
}

.error-dialog__button {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 7rem;
  min-height: 2.75rem;
  padding: 0.7rem 1.75rem;
  border: 1px solid var(--ca-primary, #0060d6);
  border-radius: var(--ca-radius-md, 0.5rem);
  background-color: var(--ca-primary, #0060d6);
  color: #ffffff;
  font: inherit;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s ease;
}

.error-dialog__button:hover {
  border-color: var(--ca-primary-dark, #1a1a86);
  background-color: var(--ca-primary-dark, #1a1a86);
}

.error-dialog__button:active {
  transform: translateY(1px);
}

.error-dialog__button:focus-visible {
  outline: 3px solid var(--ca-primary-light, #b8d8ff);
  outline-offset: 3px;
  box-shadow: 0 0 0 4px rgba(0, 96, 214, 0.14);
}

@media (max-width: 480px) {
  .error-dialog {
    padding: 0.25rem 0.25rem 0.5rem;
  }

  .error-dialog__icon-wrap {
    width: 3.75rem;
    height: 3.75rem;
    margin-bottom: 1rem;
  }

  .error-dialog__icon {
    font-size: 1.85rem;
  }

  .error-dialog__message {
    font-size: 0.9375rem;
  }

  .error-dialog__actions {
    margin-top: 1.4rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .error-dialog__button {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/dialogs/error-dialog/error-dialog.component.ts"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,sCAAsC;EACtC,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,2CAA2C;EAC3C,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,sCAAsC;EACtC,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,wCAAwC;EACxC,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,0CAA0C;EAC1C,4CAA4C;EAC5C,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf;;;;uBAIqB;AACvB;;AAEA;EACE,6CAA6C;EAC7C,iDAAiD;AACnD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mDAAmD;EACnD,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[":host {\n  display: block;\n  color: var(--ca-text-primary, #202938);\n}\n\n.error-dialog {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 32rem;\n  padding: 0.5rem 0.75rem 0.75rem;\n  color: var(--ca-text-primary, #202938);\n  background: var(--ca-surface, #ffffff);\n  text-align: center;\n}\n\n.error-dialog__icon-wrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 4.5rem;\n  height: 4.5rem;\n  margin: 0 auto 1.25rem;\n  border: 1px solid var(--ca-danger, #dc3545);\n  border-radius: 50%;\n  background-color: var(--ca-danger-bg, #fff0f1);\n}\n\n.error-dialog__icon {\n  display: block;\n  color: var(--ca-danger, #dc3545);\n  font-size: 2.15rem;\n  line-height: 1;\n}\n\n.error-dialog__content {\n  max-width: 27rem;\n  margin: 0 auto;\n}\n\n.error-dialog__title {\n  margin: 0 0 0.625rem;\n  color: var(--ca-text-primary, #202938);\n  font-size: clamp(1.4rem, 3vw, 1.7rem);\n  font-weight: 700;\n  line-height: 1.25;\n  letter-spacing: -0.015em;\n  overflow-wrap: anywhere;\n}\n\n.error-dialog__message {\n  margin: 0;\n  color: var(--ca-text-secondary, #5c6675);\n  font-size: 1rem;\n  line-height: 1.65;\n  overflow-wrap: anywhere;\n}\n\n.error-dialog__actions {\n  display: flex;\n  justify-content: center;\n  margin-top: 1.75rem;\n}\n\n.error-dialog__button {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 7rem;\n  min-height: 2.75rem;\n  padding: 0.7rem 1.75rem;\n  border: 1px solid var(--ca-primary, #0060d6);\n  border-radius: var(--ca-radius-md, 0.5rem);\n  background-color: var(--ca-primary, #0060d6);\n  color: #ffffff;\n  font: inherit;\n  font-size: 0.95rem;\n  font-weight: 600;\n  line-height: 1.2;\n  cursor: pointer;\n  transition:\n    background-color 0.2s ease,\n    border-color 0.2s ease,\n    box-shadow 0.2s ease,\n    transform 0.2s ease;\n}\n\n.error-dialog__button:hover {\n  border-color: var(--ca-primary-dark, #1a1a86);\n  background-color: var(--ca-primary-dark, #1a1a86);\n}\n\n.error-dialog__button:active {\n  transform: translateY(1px);\n}\n\n.error-dialog__button:focus-visible {\n  outline: 3px solid var(--ca-primary-light, #b8d8ff);\n  outline-offset: 3px;\n  box-shadow: 0 0 0 4px rgba(0, 96, 214, 0.14);\n}\n\n@media (max-width: 480px) {\n  .error-dialog {\n    padding: 0.25rem 0.25rem 0.5rem;\n  }\n\n  .error-dialog__icon-wrap {\n    width: 3.75rem;\n    height: 3.75rem;\n    margin-bottom: 1rem;\n  }\n\n  .error-dialog__icon {\n    font-size: 1.85rem;\n  }\n\n  .error-dialog__message {\n    font-size: 0.9375rem;\n  }\n\n  .error-dialog__actions {\n    margin-top: 1.4rem;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .error-dialog__button {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
